import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${({ height }) => height || 3}px;
  margin-bottom: 25px;

  background-color: ${colors.grayBackground};

  &::before,
  &::after {
    content: '';
    flex-grow: 1;
    background-color: ${colors.grayBackground};
  }

  &::before {
    margin-right: 10px;
  }

  &::after {
    margin-left: 10px;
  }

  ${({ text }) =>
    // eslint-disable-next-line operator-linebreak, implicit-arrow-linebreak
    text &&
    `
    &::before,
    &::after {
      flex-grow: 0;
    }
  `}
`

export const Text = styled.span`
  font-size: 14px;
  margin: 0 10px;
  color: ${colors.grayBackground};
`
